import { Injectable } from '@angular/core';
import { generateClient, GraphQLQuery, GraphQLSubscription } from '@aws-amplify/api';
import { DocumentNode } from 'graphql';

type OperationVariables = Record<string, any>;

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  private graphQlApiClient = generateClient();

  query<TData = any, TVariables extends OperationVariables = OperationVariables>(
    query: string | DocumentNode,
    variables?: TVariables,
  ) {
    return this.graphQlApiClient.graphql<GraphQLQuery<TData>>({
      query,
      variables: variables as any,
    });
  }

  subscription<TData = any, TVariables extends OperationVariables = OperationVariables>(
    query: string | DocumentNode,
    variables?: TVariables,
  ) {
    return this.graphQlApiClient.graphql<GraphQLSubscription<TData>>({
      query,
      variables: variables as any,
    });
  }
}
